export const RECENTS_TAB_ID = "recents-tab";

export const SEARCH_TAB_ID = "search-tab";
